import React from 'react';
import LandingNav from '../../landing-page/components/LandingNav';
import Footer from '../../landing-page/components/Footer';
import { footerNavigation } from '../../landing-page/contentSections';

export default function AboutPage() {
  return (
    <div className='min-h-screen bg-background flex flex-col'>
      <LandingNav />
      
      <main className='flex-grow py-20 px-6 sm:px-8 lg:px-20'>
        <div className='max-w-4xl mx-auto'>
          <h1 className='text-4xl font-extrabold tracking-tight text-foreground mb-8 text-gradient-primary'>
            About the Platform
          </h1>
          
          <div className='prose prose-slate dark:prose-invert max-w-none space-y-8'>
            <section className='bg-primary/5 border border-primary/10 p-6 rounded-2xl'>
              <h2 className='text-xl font-bold text-primary mb-3 mt-0 flex items-center gap-2'>
                <span className='w-2 h-2 bg-primary rounded-full animate-pulse'></span>
                Platform Disclaimer
              </h2>
              <p className='text-lg leading-relaxed font-medium text-foreground underline decoration-primary/20 decoration-2 underline-offset-4'>
                <strong>Important Notice:</strong> This website and platform are <strong>independently operated</strong> and are <strong>not affiliated with, endorsed by, sponsored by, or associated with the University of Ottawa (uOttawa)</strong> in any official capacity.
              </p>
              <p className='mt-4 text-muted-foreground italic'>
                We are an independent community space designed to provide resources and connectivity for students and community members. All official university matters should be directed to the uOttawa official channels.
              </p>
            </section>

            <section className='space-y-4'>
              <h2 className='text-2xl font-bold text-foreground'>Our Mission</h2>
              <p className='text-lg text-muted-foreground leading-relaxed'>
                Our goal is to create a vibrant, digital hub for the student community. We provide a space for shared resources, information, and community engagement that empowers students to connect and thrive.
              </p>
            </section>

            <section className='space-y-4'>
              <h2 className='text-2xl font-bold text-foreground'>Independent Community Support</h2>
              <p className='text-muted-foreground leading-relaxed'>
                As a third-party platform, we offer a unique space for community voice and informal connectivity. We strive to complement the student experience by providing tools and features that bridge gaps in community interaction.
              </p>
            </section>

            <section className='grid grid-cols-1 md:grid-cols-2 gap-6 pt-8'>
              <div className='p-6 rounded-xl border border-border bg-card'>
                <h3 className='font-bold text-lg mb-2'>Who is this for?</h3>
                <p className='text-sm text-muted-foreground'>
                  Designed for students, researchers, and community members looking for an unofficial and collaborative space.
                </p>
              </div>
              <div className='p-6 rounded-xl border border-border bg-card'>
                <h3 className='font-bold text-lg mb-2'>Feedback & Support</h3>
                <p className='text-sm text-muted-foreground'>
                  Have suggestions or need help? Our independent support team is here to assist you via our contact page.
                </p>
              </div>
            </section>
          </div>
        </div>
      </main>

      <Footer footerNavigation={footerNavigation} />
    </div>
  );
}
